/* eslint-disable prefer-destructuring */
import { Component, Host, h, Prop, State } from '@stencil/core';
import store, { Facet, Filter } from '../../store';
import { IntergatorConnector } from '../../../../common/intergator-connector';

@Component({
  tag: 'ui-download-search-facet',
  styleUrl: 'ui-download-search-facet.scss',
  shadow: true,
})
export class UiDownloadSearchFacet {
  @Prop() facet: Facet;

  @State() filtersOfFacetSelected = false;

  async componentWillLoad() {
    store.onChange('selectedFilters', () => {
      this.filtersOfFacetSelected = this.getSelectedFiltersOfFacet().length > 0;
      this.setTrackingFilters();
    });
  }

  setTrackingFilters() {
    if (this.filtersOfFacetSelected) {
      store.state.tracking.filters.add(this.facet.name);
    } else {
      store.state.tracking.filters.delete(this.facet.name);
    }
  }

  onCheckboxChange(filter: Filter, event: InputEvent) {
    if ((event.target as HTMLInputElement).checked) {
      store.state.helpers.addSelectedFilters([filter]);
    } else {
      store.state.helpers.removeSelectedFilters([filter]);
    }
  }

  getSelectedFiltersOfFacet() {
    return store.state.selectedFilters.filter(
      (filter) =>
        IntergatorConnector.getFacetFromFilter(filter) === this.facet.value
    );
  }

  render() {
    return (
      <Host>
        <div class="search-facet__headline">
          <ui-headline class="search-facet__headline__text" level={3}>
            {this.facet.name}
          </ui-headline>
          <ui-button
            icon="close-circle"
            variant="plain"
            onClick={() =>
              store.state.helpers.removeSelectedFilters(
                this.getSelectedFiltersOfFacet()
              )
            }
            disabled={!this.filtersOfFacetSelected}
          ></ui-button>
        </div>
        {this.facet.filters.map((filter, index) => (
          <ui-input
            onChange={(event: InputEvent) =>
              this.onCheckboxChange(filter, event)
            }
            key={index}
            type="checkbox"
            label={`${filter.name} (${filter.results})`}
            name={filter.name}
            input-id={filter.name}
            checked={store.state.selectedFilters.some(
              (selectedFilter) => selectedFilter.value === filter.value
            )}
            disabled={filter.results === 0}
          ></ui-input>
        ))}
      </Host>
    );
  }
}
